import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEBBraunTargetType, OEBBraunTargets, OEBBraunFeatureAccess, OEBBraunStartSelectionData} from './oe-bbraun-model';

export default class OEBBraunCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEBBraunTargetType.op]:        {icon: OEIconCodes.bbraun.opTarget, titleId: 'cap_bar_target_title_op'},
            [OEBBraunTargetType.anatomy]:   {icon: OEIconCodes.bbraun.anatomyTarget, titleId: 'cap_bar_target_title_anatomy'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEBBraunTargetType.op, OEBBraunTargetType.anatomy, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEBBraunTargets}
                featureAccess={OEBBraunFeatureAccess}
                startSelectionData={OEBBraunStartSelectionData}
            />
        );
    }
}